import React from "react";
import { Routes, Route, Link } from "react-router";
import * as Const from "./_Const";
import { AnimatePresence } from "framer-motion";
import PagePersonalInfo from "./PagePersonalInfo";
import PageButtons from "./PageButtons";
import PageWelcome from "./PageWelcome";
import PageRegSummary from "./PageRegSummary";
import { useLocation } from "react-router-dom";
import Splash from "./components/Splash";
import Error from "./components/Error";
import PagePersonalNumber from "./PagePersonalNumber";
import PagePersonalLastName from "./PagePersonalLastName";
import PagePersonalFirstName from "./PagePersonalFirstName";
import PagePersonalInsuranceCompany from "./PagePersonalInsuranceCompany";
import PageKeyboardTest from "./PageKeyboardTest";
import PageTerminalId from "./PageTerminalId";
import PageErrorLog from "./PageErrorLog";
import PageInsertCard from "./PageInsertCard";
import PageRemoveCard from "./PageRemoveCard";
import PageCameraTest from "./PageCameraTest";
import PageErrorLogTerminal from "./PageErrorLogTerminal";
import PageHwSwInfo from "./PageHwSwInfo";
import PageInfoPanel from "./PageInfoPanel";
import PageTestSoundLed from "./PageTestSoundLed";
import PageBrightness from "./PageBrightness";
import MouseCursor from "./components/MouseCursor";

const AnimatedRoute = () => {
  const isTerminal = Const.isTerminal();
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {!isTerminal && <Route path={Const.HOME} element={<PageWelcome />} />}

        <Route path={Const.REG_01} element={<PageButtons />} />
        <Route path={Const.REG_02} element={<PagePersonalInfo />} />
        <Route path={Const.REG_SUMMARY} element={<PageRegSummary />} />
        {isTerminal && (
          <>
            <Route path={Const.HOME} element={<PageWelcome />} />
            <Route path={Const.REG_INSERT_CARD} element={<PageInsertCard />} />
            <Route path={Const.REG_REASON_BUTTON} element={<PageButtons />} />
            <Route path={Const.REG_PERSONAL_NUMBER} element={<PagePersonalNumber />} />
            <Route path={Const.REG_LAST_NAME} element={<PagePersonalLastName />} />
            <Route path={Const.REG_NAME} element={<PagePersonalFirstName />} />
            <Route path={Const.REG_INUSRANCE} element={<PagePersonalInsuranceCompany />} />
            <Route path={Const.PAGE_TERMINAL_ID} element={<PageTerminalId />} />
            <Route path={Const.PAGE_ERROR_LOG} element={<PageErrorLog />} />
            <Route path={Const.PAGE_ERROR_LOG_TERMINAL} element={<PageErrorLogTerminal />} />
            <Route path={Const.PAGE_CAMERA_TEST} element={<PageCameraTest />} />
            <Route path={Const.REG_REMOVE_CARD} element={<PageRemoveCard />} />
            <Route path={Const.PAGE_HW_SW_INFO} element={<PageHwSwInfo />} />
            <Route path={Const.PAGE_INFO_PANEL} element={<PageInfoPanel />} />
            <Route path={Const.PAGE_TEST_SOUND_LED} element={<PageTestSoundLed />} />
            <Route path={Const.PAGE_BRIGHTNESS} element={<PageBrightness />} />
          </>
        )}

        {/* {!Const.isProduction() && <Route path={Const.PAGE_TEST} element={<PageKeyboardTest />} />} */}
        {/* {!Const.isProduction() && <Route path={Const.PAGE_TEST} element={<PagePersonalInsuranceCompany test={true} />} />} */}
        <Route path={Const.PAGE_ERROR} element={<Error />} />
        <Route
          path={Const.PAGE_ERROR_NOT_FOUND}
          element={
            <Error
              message="Tato stránka neexistuje, nebo je volána s chybnými parametry"
              message2="Opakujte načtení pomocí QR kódu nebo NFC čipu"
              subtitle="Neplatná stránka"
              showButton={isTerminal ? true : false}
            />
          }
        />
        <Route
          path={Const.PAGE_ERROR_PAGE_EXPIRED}
          element={<Error message="Tato stránka již není aktivní, protože vypršela její platnost" subtitle="Platnost stránky vypršela" showButton={false} />}
        />
        <Route
          path={Const.PAGE_ERROR_NOT_ENABLED}
          element={<Error message="V této čekárně se nelze registrovat pomocí mobilní aplikace" subtitle="Registrace není povolena" />}
        />

        {!isTerminal && <Route path="*" element={<PageWelcome />} />}

        {isTerminal && <Route path="*" element={<PageWelcome />} />}
      </Routes>
      <MouseCursor />
    </AnimatePresence>
  );
};

export default AnimatedRoute;
